import {
  addWeeks,
  differenceInYears,
  differenceInMonths,
  differenceInDays,
  addYears,
  addMonths,
} from "date-fns";

/**
 * Converts week number to an object with years, months and days.
 * @param {number} weeks - Number of weeks since birth
 * @returns {{years?: number, months: number, days: number}}
 */
export const getMonthDayFromWeek = (weeks) => {
  const birth = new Date(0); // Epoch as base
  const targetDate = addWeeks(birth, weeks);

  const years = differenceInYears(targetDate, birth);
  const yearBase = addYears(birth, years);
  const months = differenceInMonths(targetDate, yearBase);
  const monthBase = addMonths(yearBase, months);
  const days = differenceInDays(targetDate, monthBase);

  if (years >= 1) {
    return { years, months, days };
  }

  return { months, days };
};
